import { render, staticRenderFns } from "./FakePostOverlay.vue?vue&type=template&id=06080166&scoped=true&"
import script from "./FakePostOverlay.vue?vue&type=script&lang=js&"
export * from "./FakePostOverlay.vue?vue&type=script&lang=js&"
import style0 from "./FakePostOverlay.vue?vue&type=style&index=0&id=06080166&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06080166",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
